<script>
import { TextWithSize } from '@/models/text'
import TextCanvas from '@/components/common/TextCanvas.vue'
import { TextResult, TextCanvasConfig } from '@/components/common/TextCanvas.vue'
import { ErrorPayload, ErrorsModule } from '@/store/modules/error'
import MultiLineTextEditor from '@/components/common/MultiLineTextEditor.vue'
import i18n from '@/i18n'

export default {
    extends: MultiLineTextEditor,
    name: "multi-line-text-editor",
    methods: {
        validate: function() {
            let hasForbiddenChars = false
            let hasInvalidChars = false
            let forbiddeneError = { key: 'multilineForbiddenCharacters' }
            let invalidError = { key: 'multilineInvalidCharacters' }
            if (this.textInternal.match(/[<>{}]/g)) {
                forbiddeneError.message = i18n.t('forbiddenCharacters').toString().replace('&lt;','<').replace('&gt;', '>')
                ErrorsModule.SetError(forbiddeneError)
                hasForbiddenChars = true
            }
            let charArray = this.textInternal.split('')
            for (let i = 0; i < charArray.length; i++) {
                if (!this.validChars.includes(charArray[i])) {
                    invalidError.message = i18n.t('invalidCharacters').toString()
                    ErrorsModule.SetError(invalidError)
                    hasInvalidChars = true
                }
            }
            if (hasForbiddenChars || hasInvalidChars) {
                if (!hasForbiddenChars) {
                    ErrorsModule.SetError(forbiddeneError)
                }
                if (!hasInvalidChars) {
                    ErrorsModule.SetError(invalidError)
                }
                return false
            }
            ErrorsModule.SetError(forbiddeneError)
            ErrorsModule.SetError(invalidError)
            if (this.optional != true) {
                if(!this.text || this.text.trim().length === 0) {
                    return false
                }
            }
            return true
        }
    },
    components: {
        TextCanvas
    }
}
</script>